module.exports = __webpack_public_path__ + "ptc_momoro_Q1.1274e72e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_Q1.jpg
// module id = RWZ+
// module chunks = 0